import * as React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import '../style/global-styles.css';

import { Welcome } from './components/welcome/welcome';
import { Careers } from './components/careers/careers';
import { initGA } from './utils/google-analytics';
import { GS360 } from './components/gs360/gs360';
import { OverviewVideo } from './components/overview-video/overview-video';

export class App extends React.Component<{}, {}> {
  constructor() {
    super({});

    initGA();
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/careers" component={Careers} />
          <Route exact path="/welcome" component={Welcome} />
          <Route exact path="/gs360" component={GS360} />
          <Route exact path="/overviewvideo" component={OverviewVideo} />
        </Switch>
      </Router>
    );
  }
}

render(<App />, document.getElementById('reactroot'));
